export const ACW_CALL_BLOCKED_MESSAGE =
  "Tienes un ACW corriendo, solo puedes llamar a los teléfonos del contacto del ticket en ACW. Tipifica para llamar a otro contacto";

/**
 * Determines if a call should be blocked because an ACW is running and the
 * call target isn't the client tied to the ticket currently in ACW.
 * @param {boolean} inAcw - whether an ACW countdown is currently running
 * @param {string|number} acwClientId - client id of the ticket in ACW ($jssip.phone.meta.client)
 * @param {string|number} clientId - client id the call is about to be made to
 */
export function isCallBlockedByAcw(inAcw, acwClientId, clientId) {
  if (!inAcw) return false;
  return !acwClientId || acwClientId != clientId; // eslint-disable-line eqeqeq
}

export function getAcwTimeFrom(time, times, now) {
  if (!times || times.length == 0 || time == null) return 0;

  let count = 0;
  for (const index in times) {
    if (index % 2 != 0) {
      count += times[index] - times[index - 1];
    }
  }

  if (times.length % 2 == 0) {
    return time - count;
  }

  return time - (now - times[times.length - 1]) - count;
}
